// file path: src\stores\auth.store.ts

import { configureStore } from '@reduxjs/toolkit';
import ddCalculatorReducer from '../pages/DDCalculator/stores/dd-calculator.slice';

export const store = configureStore({
  reducer: {
    ddCalculator: ddCalculatorReducer
  },
});

// Define the RootState and AppDispatch types based on the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
